import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c19c1c7&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "../../../../styles/scoped.scss?vue&type=style&index=0&id=3c19c1c7&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c19c1c7",
  null
  
)

export default component.exports